// extracted by mini-css-extract-plugin
export var cardIcon = "_o-5";
export var cardIconUnframed = "_o-9";
export var checkboxCard = "_o-0";
export var checkboxCardSelected = "_o-4";
export var disabled = "_o-2";
export var interactive = "_o-1";
export var outerBorder = "_o-3";
export var spacerMedium = "_o-8";
export var spacerSmall = "_o-7";
export var spacerXsmall = "_o-6";